/* MIONA Creator / Asset Package
   Sticky-Chapter-Nav: aktives Kapitel hervorheben + sanftes Scrollen. */
(function () {
  "use strict";
  var nav = document.querySelector(".pk-nav");
  if (!nav) return;
  var links = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
  if (!links.length) return;

  // Ziel-Anker einsammeln
  var targets = links
    .map(function (a) {
      var id = a.getAttribute("href").slice(1);
      var el = document.getElementById(id);
      return el ? { a: a, el: el } : null;
    })
    .filter(Boolean);

  // Sanftes Scrollen (mit Offset für die Sticky-Nav)
  links.forEach(function (a) {
    a.addEventListener("click", function (e) {
      var id = a.getAttribute("href").slice(1);
      var el = document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var offset = nav.offsetHeight + 12;
      var top = el.getBoundingClientRect().top + window.pageYOffset - offset;
      window.scrollTo({ top: top, behavior: "smooth" });
    });
  });

  // Aktiven Link per Scroll-Position bestimmen
  function setActive() {
    var pos = window.pageYOffset + nav.offsetHeight + 80;
    var current = targets[0];
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].el.offsetTop <= pos) current = targets[i];
    }
    links.forEach(function (a) { a.classList.remove("is-active"); });
    if (current) current.a.classList.add("is-active");
  }

  var ticking = false;
  window.addEventListener(
    "scroll",
    function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        setActive();
        ticking = false;
      });
    },
    { passive: true }
  );
  setActive();
})();
